export interface IOrdersTypes {
  id: "install" | "rate";
  title: "Installs" | "Rates";
}

export const ORDERS_TYPES: IOrdersTypes[] = [
  { id: "install", title: "Installs" },
  { id: "rate", title: "Rates" },
];
